<div class="chat-create-form" [formGroup]="form">
  <app-photo
    class="chat-create-form__avatar"
    [mode]="'create'"
    [type]="'chat'"
    [height]="isLargeScreen ? '144px' : '96px'"
    [width]="isLargeScreen ? '144px' : '96px'"
    [borderRadius]="isLargeScreen ? '144px' : '96px'"
    [rounded]="true"
    [loading]="loading"
    (photoChange)="onPhotoChange($event)"
  ></app-photo>

  <tui-input
    class="chat-create-form__field"
    tabindex="1"
    formControlName="chatName"
    [class.tui-skeleton]="loading"
    [class.tui-skeleton_text]="loading"
    [tuiTextfieldSize]="tuiElementLargeSize"
  >
    {{ 'components.chatCreateForm.fields.chatName' | translate }}

    <span class="tui-required"></span>
    <input tuiTextfieldLegacy appTestingId="Input.chatName" />
  </tui-input>

  <tui-input
    class="chat-create-form__field"
    tabindex="2"
    formControlName="chatDescription"
    [class.tui-skeleton]="loading"
    [class.tui-skeleton_text]="loading"
    [tuiTextfieldSize]="tuiElementLargeSize"
  >
    {{ 'components.chatCreateForm.fields.chatDescription' | translate }}

    <input tuiTextfieldLegacy appTestingId="Input.chatDescription" />
  </tui-input>

  <app-field-wrapper
    [text]="'components.chatCreateForm.fields.onlyForAdmins' | translate"
    [size]="tuiElementMediumSize"
    [class.tui-skeleton]="loading"
    [class.tui-skeleton_text]="loading"
  >
    <app-toggle tabindex="3" formControlName="onlyForAdmins" [size]="tuiElementMediumSize"></app-toggle>
  </app-field-wrapper>

  <div class="chat-create-form__field" [class.tui-skeleton]="loading" [class.tui-skeleton_text]="loading">
    <search-users-input
      formControlName="members"
      mode="multiple"
      [label]="'common.labels.members' | translate"
      [pluralize]="[
        'common.labels.memberOne' | translate,
        'common.labels.memberFew' | translate,
        'common.labels.memberMany' | translate,
      ]"
      [excludeUsersIds]="authUserId ? [authUserId] : undefined"
      [showFilterButton]="true"
      [textfieldSize]="tuiElementLargeSize"
    ></search-users-input>
  </div>

  <div class="chat-create-form__buttons">
    <button
      tuiButton
      appearance="secondary"
      type="button"
      [size]="tuiElementLargeSize"
      [disabled]="loading"
      (click)="cancel()"
    >
      {{ 'common.buttons.cancel' | translate }}
    </button>

    <button tuiButton type="button" [size]="tuiElementLargeSize" [disabled]="loading" (click)="apply()">
      {{ 'common.buttons.save' | translate }}
    </button>
  </div>
</div>
